import gql from 'graphql-tag';

import postFragment from '~/shared/graphql-queries/posts/post-fragment';

export default gql`
  mutation updateByIdPostMutation(
    $_id: MongoID!
    $record: UpdateByIdPostInput!
  ) {
    updateByIdPostMutation(_id: $_id, record: $record) {
      recordId
      record {
        ...PostFragment
      }
      message
      title
    }
  }
  ${postFragment}
`;
